import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './Spinner.module.scss';

export type SpinnerProps = {
  className?: string;
};

const Spinner: React.FC<SpinnerProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cx(styles.container, className)} >
      <div role="alert" aria-atomic="true" className={styles.spinner}>
        <span className={styles.hideLoadingTextFromScreen}>{t('loading.loadingMessageForScreenReader')}</span>
      </div>
    </div>
  );
};

export default Spinner;
